import { render, staticRenderFns } from "./active_user.vue?vue&type=template&id=39d82bcc&scoped=true"
import script from "./active_user.vue?vue&type=script&lang=ts"
export * from "./active_user.vue?vue&type=script&lang=ts"
import style0 from "./active_user.vue?vue&type=style&index=0&id=39d82bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d82bcc",
  null
  
)

export default component.exports